import { SessionCloseCode } from 'api'
import { Locale, Translation } from 'locale'

export function shouldInvalidateCredentials(closeCode: number | null): boolean {
  return (
    closeCode === SessionCloseCode.USER_SUSPENDED ||
    closeCode === SessionCloseCode.SESSION_EXPIRED ||
    closeCode === SessionCloseCode.DUPLICATE_SESSION
  )
}

export function socketCloseReason(closeCode: number | null): string {
  switch (closeCode) {
    case SessionCloseCode.SESSION_EXPIRED:
      return Locale.translate(Translation.SC_CLOSECODE_SESSION_EXPIRED)
    case SessionCloseCode.USER_SUSPENDED:
      return Locale.translate(Translation.SC_CLOSECODE_USER_DISABLED)
    default:
      return ''
  }
}
